import { DateTime } from 'luxon';

export const formatIsoDateToUKFormat = (date: string): string =>
    DateTime.fromISO(date, { zone: 'Europe/London' }).toFormat(
        'dd/LL/yyyy HH:mm',
    );
